import { check_personalnumber_no, orgNummer } from '../../../util/validering/valideringsRutiner'

const getValidatePnr = (errorMessage) => {

    const isValidPnr = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (formState.debtorType.toLowerCase() === 'privat')
            return ''

        if (check_personalnumber_no(val.replace(" ", ""))) {
            return ''
        }
        return errorMessage
    }
    return isValidPnr
}

const getValidateOrgNr = (errorMessage) => {

    const isValidOrgNr = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (formState.debtorType.toLowerCase() === 'privat')
            return ''
        
        if (orgNummer(val.replace(" ", ""))) {
            return ''
        }
        return errorMessage
    }
    return isValidOrgNr
}

const stringToDate = function (dateString) {
    const [dd, mm, yyyy] = dateString.split(".");
    return new Date(`${yyyy}-${mm}-${dd}`);
};

const getIsBeyondToday = (errorMessage, length) => {

    const isBeyondToday = (val, name, formState) => {

        if (!val) {
            return ''
        }

        let CurrentDate = new Date()
        let GivenDate = stringToDate(val)

        if (GivenDate > CurrentDate) {
            return errorMessage
        } else {
            return ''
        }
    }

    return isBeyondToday
}

function deltaDate(input, days, months, years) {
    return new Date(
        input.getFullYear() + years,
        input.getMonth() + months,
        Math.min(
            input.getDate() + days,
            new Date(input.getFullYear() + years, input.getMonth() + months + 1, 0).getDate()
        )
    );
}

const getIsNotToOld = (errorMessage, length) => {

    const isBeyondToday = (val, name, formState) => {

        if (!val) {
            return ''
        }

        let minDate = deltaDate(new Date(), 0, 0, -105);
        let GivenDate = stringToDate(val)

        if (GivenDate < minDate) {
            return errorMessage
        } else {
            return ''
        }
    }

    return isBeyondToday
}



const getValidateEmail = (errorMessage) => {

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    // const re2 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

    // https://www.w3resource.com/javascript/form/email-validation.php
    const validateEmail = (val, name, formState) => {

        //if (formState.debtorType.toLowerCase() !== 'privat')
        //    return ''
        if (val === '') {
            return ''
        } else{
            if (re.test(val)) {
                return ''
            }
        }

        return errorMessage
    }

    return validateEmail
}

const getIsRequired = (errorMessage) => {

    const isRequired = (val, name, formState) => {
        //console.log ('is not blank', val)
        if (val) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}

const getIsRequiredIfDebtorType = (errorMessage, debtorType) => {

    const isRequired = (val, name, formState) => {

        // Annen type enn næreing/privat ?
        if (formState.debtorType.toLowerCase() !== debtorType.toLowerCase())
            return ''
        
        //console.log ('is not blank', val)
        if (val) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}

const getMinLenght = (errorMessage, length) => {

    const isRequired = (val, name, formState) => {

        if (!val) {
            return ''
        }
        else if (val.length >= length) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}

// if (formState.debtorType === 'privat')
const getMaxLenghtName = (errorMessage) => {

    const isRequired = (val, name, formState) => {

        let len = 40
        if (formState.debtorType.toLowerCase() === 'privat') {
            len = 80
        }

        if (!val) {
            return ''
        }
        else if (val.length <= len) {
            return ''
        }
        else {
            return errorMessage + len
        }
    }

    return isRequired
}

const getMaxLenght = (errorMessage, length) => {

    const isRequired = (val, name, formState) => {

        if (!val) {
            return ''
        }
        else if (val.length <= length) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}

const getForfallEtterFaktDate = (errorMessage, length) => {

    const validatorFunc = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (!formState.fakturadato) {
            return ''
        }

        let fakturaDate = stringToDate(formState.fakturadato)
        let forfall = stringToDate(val)

        if (forfall < fakturaDate) {
            return errorMessage
        } else {
            return ''
        }
    }

    return validatorFunc
}


const getIsBeyondThreeYearOld = (errorMessage, length) => {

    const isBeyondToday = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (val.length !== 10) {
            return ''
        }
        
        let CurrentDateThreeAYearsAgo = new Date()
        let thisYear = CurrentDateThreeAYearsAgo.getFullYear()
        CurrentDateThreeAYearsAgo.setFullYear(thisYear-3)
        let GivenDate = stringToDate(val)

        if (GivenDate < CurrentDateThreeAYearsAgo) {
            return errorMessage
        } else {
            return ''
        }
    }

    return isBeyondToday
}

// Sjekker om for nærme foreldelse. Foreldelse er 3 år tilbake i tid så vi sjekker om fakturadato er senest (tidligst?) 35 mnd siden.
// Alt som er 3 år eller eldre blir allerede dekket av getIsBeyondThreeYearOld
const getIsBeyond35MonthsOld = (errorMessage, length) => {
    const isBeyondToday = (val, name, formState) => {
        if (!val) {
            return '';
        }

        if (val.length !== 10) {
            return '';
        }

        let givenDate = stringToDate(val);

        let threeYearsAgo = new Date();
        threeYearsAgo.setMonth(threeYearsAgo.getMonth() - 36);

        let thirtyFiveMonthsAgo = new Date();
        thirtyFiveMonthsAgo.setMonth(thirtyFiveMonthsAgo.getMonth() - 35);

        if (givenDate >= threeYearsAgo && givenDate < thirtyFiveMonthsAgo) {
            return errorMessage;
        }

        return '';
    };

    return isBeyondToday;
};



// Validators ved eksisterende debitor
export const GetFormValidators = (messages) => {
    const produktTypeIsRequired = getIsRequired(messages['produktTypeisRequired'])
    const referanseNummerIsRequired = getIsRequired(messages['referanseNummerIsRequired'])
    const maxLength15 = getMaxLenght(messages['maxLength'] + '15', 15)

    const formValidatorsExist = {
        produktType: [
            produktTypeIsRequired,
        ],
        referanseNummer: [
            // Ikke lenger påkrevd
            //referanseNummerIsRequired,
        ],
        phone: [
            maxLength15,
        ],
    }

    return formValidatorsExist
}

// Validators ved ny debitor
export const GetFormValidatorsNew = (messages) => {

    const produktTypeIsRequired = getIsRequired(messages['produktTypeisRequired'])

    const debtorTypeIsRequired = getIsRequired(messages['debtorTypeisRequired'])
    
    const postalAddressIsRequired = getIsRequired(messages['requiredPostalAddressisRequired'])
    const postalCodeIsRequired = getIsRequired(messages['requiredPostalCodeisRequired'])
    const postalPlaceIsRequired = getIsRequired(messages['requiredPostalPlaceisRequired'])

    const debtorNameisRequired = getIsRequiredIfDebtorType(messages['requiredDebtorNameisRequired'], 'næring')
    const firstNameisRequired = getIsRequiredIfDebtorType(messages['requiredFirstNameisRequired'], 'privat')
    const lastNameisRequired = getIsRequiredIfDebtorType(messages['requiredLastNameisRequired'], 'privat')

    const minLength3 = getMinLenght(messages['minLength3'], 3)
    const minLength9 = getMinLenght(messages['requiredNotValidOrgnr'], 11)
    const minLength10 = getMinLenght(messages['minLength10'], 10)
    const maxLenghtName = getMaxLenghtName(messages['maxLength'])

    const maxLength80 = getMaxLenght(messages['maxLength'] + '80', 80)
    const maxLength40 = getMaxLenght(messages['maxLength'] + '40', 40)
    const maxLength63 = getMaxLenght(messages['maxLength'] + '63', 63)
    const maxLength15 = getMaxLenght(messages['maxLength'] + '15', 15)
    const maxLength29 = getMaxLenght(messages['maxLength'] + '29', 29)

    const validEmail = getValidateEmail(messages['notValidEmail'])

    const validOrgNr = getValidateOrgNr(messages['notValidOrgnr'])
    const isBeyondToday = getIsBeyondToday(messages['isBeyondToday'], 10)
    const isNotToOld = getIsNotToOld(messages['isTooOld'], 10)

    const fakturanummerIsRequired = getIsRequired(messages['requiredFakturanummerIsRequired'])
    const fakturatekstIsRequired = getIsRequired(messages['requiredFakturatekstIsRequired'])
    const forfallsdatoIsRequired = getIsRequired(messages['requiredForfallsdatoIsRequired']) 
    const isBeyondThreeYearsOld = getIsBeyondThreeYearOld(messages['isBeyondThreeYearsOld'])
    const isBeyondThreeYearsOldForfall = getIsBeyondThreeYearOld(messages['isBeyondThreeYearsOldForfall'])
    const isBeyond35MonthsOld = getIsBeyond35MonthsOld(messages['isBeyond35MonthsOld'])
    const fakturadatoIsRequired = getIsRequired(messages['requiredFakturadatoIsRequired'])
    const valutaIsRequired = getIsRequired(messages['requiredValutaIsRequired'])
    const belopIsRequired = getIsRequired(messages['requiredBelopIsRequired'])

    const isForfallOk = getForfallEtterFaktDate(messages['isForfallOk'], 10)

    const validPnr = getValidatePnr('nope');

    const formValidators = {
        //Debitor validatorer
        produktType: [
            produktTypeIsRequired,
        ],
        customerType: [
            debtorTypeIsRequired,
        ],
        requiredBirthDate: [
            isBeyondToday,
            minLength10,
            isNotToOld,
        ],
        requiredBirthNumber: [
            validPnr
        ],
        requiredStreetAddress: [
            maxLength63
        ],
        requiredPostalAddress: [
            postalAddressIsRequired,
            maxLength63
        ],
        requiredPostalCode: [
            postalCodeIsRequired
        ],
        requiredPostalPlace: [
            postalPlaceIsRequired
        ],
        requiredDebtorName: [
            debtorNameisRequired,
            minLength3,
            maxLenghtName,
        ],
        requiredFirstName: [
            firstNameisRequired,
            minLength3,
        ],
        requiredLastName: [
            lastNameisRequired,
            minLength3,
        ],
        requiredDebtorIdentificationNumber: [
            minLength9,
        ],
        requiredEmail: [
            validEmail,
        ],
        requiredPhone: [
            maxLength15,
        ],

        // Faktura validatorer
        requiredFakturanummer: [
            fakturanummerIsRequired
        ],
        requiredKid: [
        ],
        requiredFakturatekst: [
            fakturatekstIsRequired,
            maxLength29
        ],
        requiredForfallsdato: [
            forfallsdatoIsRequired,
            minLength10,            
            isBeyondToday,
            isBeyondThreeYearsOldForfall,
            isForfallOk,
        ],
        requiredFakturadato: [
            fakturadatoIsRequired,
            minLength10,
            isBeyondToday,
            isBeyond35MonthsOld,
            isBeyondThreeYearsOld,
        ],
        valuta: [
            valutaIsRequired
        ],
        requiredBelop: [
            belopIsRequired
        ]    

    }

    return formValidators
}